module.exports = __webpack_public_path__ + "assets/img/zpbj1.e99096b1.png";